import DocumentPhotoIndex from "./DocumentPhotoIndex.vue";
import DocumentPhotoAdd from "./DocumentPhotoAdd.vue";
import DocumentPhotoDetail from "./DocumentPhotoDetail.vue";
import DocumentPhotoEdit from "./DocumentPhotoEdit.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List DocumentPhoto",
        },
        name: "DocumentPhotoView",
        component: DocumentPhotoIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create DocumentPhoto",
        },
        name: "DocumentPhotoAdd",
        component: DocumentPhotoAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail DocumentPhoto",
        },
        name: "DocumentPhotoDetail",
        component: DocumentPhotoDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit DocumentPhoto",
        },
        name: "DocumentPhotoEdit",
        component: DocumentPhotoEdit
    },
    
]

export default routes
  